export enum BurgerColor {
  White = 0,
  Black = 1,
}
